// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD7phjdp3sHQPBUZsjIP-K13b2uelP0Nq0",
    authDomain: "l-amidon-e4d07.firebaseapp.com",
    databaseURL: "https://l-amidon-e4d07.firebaseio.com",
    projectId: "l-amidon-e4d07",
    storageBucket: "l-amidon-e4d07.appspot.com",
    messagingSenderId: "85185534515",
    appId: "1:85185534515:web:3111517a52270fd8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
